//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TreeSelect from "@/components/TreeSelect.vue";
import ServeDialog from "@/components/management/serve/ServeDialog.vue";
import UseServeInfoDialog from "@/components/management/serve/useServeInfoDialog.vue";
import { getServePage, getServeInfo, handleServeDelete, useOrDisuse } from "@/api/managementCenter/serveManage";
import { getDeptTree } from "@/api/managementCenter/otherApi";
export default {
  name: "Theme",
  components: {
    TreeSelect: TreeSelect,
    ServeDialog: ServeDialog,
    UseServeInfoDialog: UseServeInfoDialog
  },
  props: [],
  data: function data() {
    return {
      selectionChecked: [],
      serveTypeList: [{
        name: "请选择",
        value: ""
      }, {
        name: "查询类",
        value: "0"
      }, {
        name: "审批类",
        value: "1"
      }],
      departmentData: [],
      mapKey: {
        id: "id",
        // ID
        label: "name",
        // 显示名称
        children: "children" //子级字段名

      },
      loading: false,
      list: [],
      pageSizes: [10, 20, 30, 50, 100],
      paramSearch: {
        current: 1,
        size: 10,
        watchDeptId: "",
        serveType: "",
        serveName: ""
      },
      total: 0
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.getListFn();
    this.getDeptTreeData();
  },
  methods: {
    getDeptTreeData: function getDeptTreeData() {
      var _this = this;

      getDeptTree().then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          _this.departmentData = data.data;
        }
      }).catch(function (err) {});
    },
    setDeptSingleMenu: function setDeptSingleMenu(key, data) {
      this.paramSearch.watchDeptId = data.id;
    },
    // 获取查询列表
    getListFn: function getListFn() {
      var _this2 = this;

      this.loading = true;
      getServePage(this.paramSearch).then(function (_ref2) {
        var data = _ref2.data;
        _this2.loading = false;

        if (data.code == 0) {
          _this2.selectionChecked = [];
          _this2.list = data.data.records || [];
          _this2.total = data.data.total;
        }
      }).catch(function () {
        _this2.loading = false;
      });
    },
    // 添加
    addFn: function addFn() {
      this.$refs.serveDialog.dialogShow("add");
    },
    // 删除
    deleteFn: function deleteFn(id) {
      var _this3 = this;

      this.$confirm("是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this3.deleteHttp(id);
      }).catch(function () {
        _this3.$message.info("已取消删除");
      });
    },
    deleteHttp: function deleteHttp(id) {
      var _this4 = this;

      this.loading = true; // 删除接口

      handleServeDelete(id).then(function (_ref3) {
        var data = _ref3.data;
        _this4.loading = false;

        if (data.code == 0) {
          _this4.$message.success("删除成功!");

          _this4.getListFn();
        } else {
          _this4.$message.warning(data.msg || "删除失败！");
        }
      }).catch(function () {
        _this4.loading = false;

        _this4.$message.error("删除异常!");
      });
    },
    // 详情
    editFn: function editFn(id) {
      var _this5 = this;

      this.loading = true;
      getServeInfo(id).then(function (_ref4) {
        var data = _ref4.data;
        _this5.loading = false;

        if (data.code == 0) {
          _this5.$refs.serveDialog.dialogShow("edit", data.data);
        } else {
          _this5.$message.warning(data.msg || "获取服务信息失败！");
        }
      }).catch(function (err) {
        _this5.loading = false;
      });
    },
    //监控
    useInfoFn: function useInfoFn(row) {
      this.$refs.useServeInfoDialog.dialogShow(row);
    },
    // 收搜数据
    searchFn: function searchFn() {
      this.paramSearch.current = 1;
      this.getListFn();
    },
    // 条数
    changeSize: function changeSize(value) {
      this.paramSearch.size = value;
      this.paramSearch.current = 1;
      this.getListFn();
    },
    // 翻页
    changePage: function changePage(value) {
      this.paramSearch.current = value;
      this.getListFn();
    },
    saveSuccess: function saveSuccess() {
      this.getListFn();
    },
    useOrDisuseFn: function useOrDisuseFn(params) {
      var _this6 = this;

      useOrDisuse(params).then(function (_ref5) {
        var data = _ref5.data;
        _this6.loading = false;

        if (data.code == 0) {
          _this6.$message.success(data.msg || "操作成功!");

          _this6.getListFn();
        } else {
          _this6.$message.warning(data.msg || "操作失败!");
        }
      }).catch(function (err) {
        _this6.loading = false;

        _this6.$message.error(data.msg || "操作异常!");
      });
    },
    switchUseFlagFn: function switchUseFlagFn(id, value) {
      var params = {
        serveIds: id,
        useFlag: value == 1 ? "0" : "1"
      };
      this.useOrDisuseFn(params);
    },
    batchUseFn: function batchUseFn(useFlag) {
      if (this.selectionChecked.length == 0) {
        this.$message.warning("请选择服务!");
        return;
      }

      var data = this.selectionChecked.map(function (i) {
        return i.id;
      });
      var params = {
        serveIds: data.join(","),
        useFlag: useFlag
      };
      this.useOrDisuseFn(params);
    },
    changeFun: function changeFun(val) {
      this.selectionChecked = val;
    }
  },
  watch: {},
  filters: {}
};